import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_CUSTOM_TONE_OF_VOICE } from './schema';

const MUTATION = gql`
  mutation UpdateCustomToneOfVoice(
    $id: ID!
    $name: String
    $description: String
    $defaultForGenerationTools: [GenerationToolEnum!]
    $traits: [Trait!]
    $personality: TovDefaultPresetEnum
  ) {
    updateCustomToneOfVoice(
      id: $id
      name: $name
      description: $description
      defaultForGenerationTools: $defaultForGenerationTools
      traits: $traits
      personality: $personality
    ) {
      ...CustomToneOfVoice
    }
  }

  ${FRAGMENT_CUSTOM_TONE_OF_VOICE}
`;

export const updateCustomToneOfVoice = ({
  id,
  name,
  description,
  defaultForGenerationTools,
  traits,
  personality,
}) => {
  const variables = {
    id,
    name,
    description,
    defaultForGenerationTools,
    traits,
    personality,
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
  }).then(({ data }) => getSingleProp(data));
};
